import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":"","max-width":"400"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c(VIcon,_vm._g(_vm._b({staticClass:"ml-2",attrs:{"small":"","color":"be-primary-pure"}},'v-icon',attrs,false),on),[_vm._v(" fa-question-circle ")])]}}])},[_vm._t("tooltip-text",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }